const INVITE_SENT_SUCCESS =
  'Your invite has been sent. You may need to wait up to 24-48 hours for a response.';
const CONTACT_SENT_SUCCESS =
  'Your contact request has been sent to the freelancer.';

export { INVITE_SENT_SUCCESS, CONTACT_SENT_SUCCESS };
